import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StoryPage from "../pages/story/page";
import InvestingPage from "../pages/investing/page";
import BuildingPage from "../pages/building/page";
import AdvisoryPage from "../pages/advisory/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/story", element: <StoryPage /> },
  { path: "/investing", element: <InvestingPage /> },
  { path: "/building", element: <BuildingPage /> },
  { path: "/advisory", element: <AdvisoryPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;